import { FuelTypography } from '@frete.com/fuel-react';
import { useAppStates } from 'hooks/useAppStates';
import React, { FC } from 'react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { dsTheme } from 'constants/styled.contants';
import { MESSAGES_INFO } from './constants';

import * as Styled from './styled';

const EmptyRefundableList: FC = () => {
  const { isEmptyRefundableFare } = useAppStates();

  return (
    <>
      {isEmptyRefundableFare && (
        <FuelFlex
          defaultProps={{
            alignItems: 'center',
            justifyContent: 'center',
            customMargin: `${dsTheme.spacing.km10} 0 0 0`,
            width: '100%',
          }}
        >
          <Styled.Content>
            <FuelTypography size="heading-sm" weight="bold" tag="h4">
              {MESSAGES_INFO.refundableFareNoPayment.title}
            </FuelTypography>

            <Styled.ContentText>
              <FuelTypography color="neutral-default" size="body-sm">
                {MESSAGES_INFO.refundableFareNoPayment.text}
              </FuelTypography>
            </Styled.ContentText>
          </Styled.Content>
        </FuelFlex>
      )}
    </>
  );
};

export default EmptyRefundableList;
